import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CustomComponent, IQuestionHelpTextDetails } from '@cakeiteasy/web-utils';

@Component({
  standalone: false,
  selector: 'cake-variants-section',
  templateUrl: './cake-variants-section.component.html'
})
export class CakeVariantsSectionComponent extends CustomComponent {
  @Input() disabled: boolean;
  @Input() active: boolean;
  @Input() isPieces: boolean;
  @Input() variants: any[];
  @Input() activeVariant: any;
  @Input() currency = 'kr';
  @Input() discount: number;
  @Input() details: IQuestionHelpTextDetails;

  @Output() onSelect = new EventEmitter<any>();
}
